import login from './login'
import getUserInfo from './getUserInfo'
import getGPS from './getGPS'
import scanQRcode from './scanQRcode'
import alert from './alert'
import confirm from './confirm'
import requestMethod from './requestMethod'
import singleShake from './singleShake'
import showProgress from './showProgress'
import hiddenProgress from './hiddenProgress'
import hiddenNavigation from './hiddenNavigation'
import showNavigation from './showNavigation'
import openNewWebView from './openNewWebView'
import closeWebView from './closeWebView'
import webViewReset from './webViewReset'
import modifyNavigationTitle from './modifyNavigationTitle'
import createTribe from './createTribe'
import joinToTribe from './joinToTribe'
import openTribe from './openTribe'
import noticeBroad from './noticeBroad'
import openPerson from './openPerson'
import openPersonWithKey from './openPersonWithKey'
import shakeOneShake from './shakeOneShake'
import saveImage from './needBackAction'
import needBackAction from './needBackAction'
import giveBackAction from './giveBackAction'
import makePhoneCall from './makePhoneCall'
import getEDUUserInfo from './getEDUUserInfo'
import apiCheckAppUpdate from './apiCheckAppUpdate'
import phoneInfo from './phoneInfo'
import apiSetupNav from './apiSetupNav'
import apiAppOpenService from './apiAppOpenService'

const modules = {
    login,
    getGPS,
    getUserInfo,
    scanQRcode,
    alert,
    confirm,
    singleShake,
    showProgress,
    hiddenProgress,
    hiddenNavigation,
    showNavigation,
    closeWebView,
    webViewReset,
    modifyNavigationTitle,
    createTribe,
    joinToTribe,
    openTribe,
    noticeBroad,
    openPerson,
    openPersonWithKey,
    shakeOneShake,
    saveImage,
    needBackAction,
    giveBackAction,
    makePhoneCall,
    requestMethod,
    openNewWebView,
    getEDUUserInfo,
    apiCheckAppUpdate,
    phoneInfo,
    apiSetupNav,
    apiAppOpenService
}

export default modules